import { NavigateFunction, useLocation, useNavigate } from 'react-router-dom';
import { toLower } from 'lodash';

interface UseNavigationResult {
  navigateTo: (route: string, state?: object) => void;
  navigate: NavigateFunction;
}

export function useNavigation(): UseNavigationResult {
  const location = useLocation();
  const navigate = useNavigate();

  const navigateTo = (route: string, state?: object) => {
    if (route.charAt(0) !== '/') {
      const formatedRoute = toLower(`/${route}`).replace(/\s/g, '_');

      navigate(formatedRoute, { state: { ...state, from: location.pathname } });

      return;
    }

    navigate(route, { state: { ...state, from: location.pathname } });
  };

  return { navigate, navigateTo };
}
